import React from 'react';
import { ZapIcon } from 'lucide-react';
import { painPoints } from '../data/content';
import { toneAt } from '../utils/iconTones';
export function ProblemSection() {
  return <section className="w-full bg-cream-100 px-6 py-14 sm:py-16" aria-labelledby="problema-titulo" data-id="element-145" data-mp="30h7khm1pposz">
      <div className="mx-auto max-w-5xl text-center" data-id="element-146" data-mp="2vqhi8hol222i">
        <h2 id="problema-titulo" className="mx-auto max-w-3xl font-display text-3xl font-bold leading-[1.15] text-forest-800 sm:text-4xl lg:text-[2.9rem]" data-id="element-147" data-mp="2vowlqmipk920">
          ¿Cuántas clases más vas a preparar sobre Instrumentación sin tener el sistema completo?
        </h2>

        <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-forest-700/85 sm:text-lg" data-id="element-148" data-mp="3jglge9j059m4">
          Buscás contenido actualizado sin encontrar referencias claras. Y cuando un alumno pregunta sobre
          Industria 4.0, protocolos WirelessHART o cómo funciona el Edge Computing en la medición real, no tenés
          dónde buscar respuestas técnicas verificadas.
        </p>

        <p className="mx-auto mt-6 flex max-w-2xl items-start justify-center gap-3 rounded-2xl bg-cream-200/70 px-6 py-4 text-base font-medium text-forest-800" data-id="element-149" data-mp="jdn5i4pl305g">
          <ZapIcon className="mt-1 h-5 w-5 shrink-0 text-ember-500" aria-hidden="true" data-id="element-150" data-mp="oa3ut28irkk4" />
          <span data-id="element-151" data-mp="scidnmc6ukbe">
            No es falta de experiencia docente. Es que el material de instrumentación moderna no existe
            compilado en un solo lugar.
          </span>
        </p>

        <h3 className="mt-8 text-base font-medium text-forest-700/85" data-id="element-152" data-mp="12335mqxcwqlc">Esto quizás te está pasando hoy:</h3>

        <ul className="mt-5 grid gap-3 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-153" data-mp="170v0nttasstr">
          {painPoints.map(({
          icon: Icon,
          title,
          description
        }, index) => <li key={title} className="flex h-full flex-col rounded-xl border border-cream-300/70 bg-cream-50 p-4 transition-[transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-card" data-id="element-154" data-mp="1g22tvxgyj3gz" data-mpi={index}>
              <div className="flex items-center gap-2.5" data-id="element-155" data-mp="3hv0tcc58ouaw">
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${toneAt(index).bg}`} data-id="element-156" data-mp="ozh5oh96jcos">
                  <Icon className={`h-3.5 w-3.5 ${toneAt(index).fg}`} aria-hidden="true" data-id="element-157" data-mp="k2h8kvub5k9t" />
                </span>
                <h4 className="text-sm font-semibold leading-tight text-forest-800" data-id="element-158" data-mp="y2i7i5r0ihmn">{title}</h4>
              </div>
              <p className="mt-2.5 text-[0.8rem] leading-relaxed text-forest-700/85" data-id="element-159" data-mp="u1galvkkihnu">{description}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl font-display text-xl font-semibold italic leading-snug text-forest-700 sm:text-2xl" data-id="element-160" data-mp="130bcwwkhr7lv">
          ¿Y si esta fuera la última semana que enseñás Instrumentación sin tener el ecosistema completo?
        </p>
      </div>
    </section>;
}